import React, { useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const AddHome = () => {
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    type: "",
    status: 1,
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");

  const {
    AuthReducer: { auth },
  } = useSelector((state) => state);

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value, checked, files } = e.target;

    if (files && files.length > 0) {
      setFile(files[0]);
    } else if (name === "status") {
      setFormData({ ...formData, [name]: checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    const form = new FormData();
    // if (file) {
    //   form.append(formData.type === "image" ? "image" : "video_url", file);
    // }
    if (file) form.append("file", file);
    Object.keys(formData).forEach((key) => {
      form.append(key, formData[key]);
    });

    axios
      .post(`/api/admin/v1/add-home`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        const errMsg = err.response?.data?.message || "Something went wrong";
        setErrors(err.response?.data?.errors || {});
        setMessage(errMsg);
        toast.error(errMsg);
      });
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Home</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2 my-4">
        <div className="row">
          <h3 className="d-block text-danger text-center">{message}</h3>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label className="text-black">Type</Label>
              <Input value={formData.type} type="select" name="type" onChange={inputHandler}>
                <option value="">Select Type</option>
                <option value="image">Image</option>
                <option value="video">Video</option>
              </Input>
              <span className="d-block text-danger">{errors?.type}</span>
            </FormGroup>
          </div>
          {formData.type && (
            <div className="col-md-4 offset-md-1">
              <FormGroup>
                <Label>Upload {formData.type === "image" ? "Image" : "Video"}</Label>
                <Input type="file" name={formData.type === "image" ? "image" : "video_url"} accept={formData.type === "image" ? "image/*" : "video/*"} onChange={inputHandler} />
                <span className="d-block text-danger">{errors?.[formData.type]}</span>
              </FormGroup>
            </div>
          )}
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input type="switch" checked={formData.status} onChange={inputHandler} name="status" />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHome;
